import { useQuery } from "@tanstack/react-query";
import { ServiceMap } from "../../types";
import { serviceMapService } from "../../services/serviceMapService";

export const useServiceMap = (serviceMapId?: string) => {
  return useQuery<ServiceMap>({
    enabled: !!serviceMapId,
    queryKey: ["serviceMapId", serviceMapId],
    queryFn: async () => serviceMapService.getWithComputedStatuses(serviceMapId!),
  });
};
